export default __webpack_public_path__ + "static/media/telegramDeskFill.e999fcc6.svg";